<template>
  <div class="password-policy-hints text-body-2 mb-2">
    <div
      v-for="row in rows"
      :key="row.key"
      class="d-flex align-center ga-1 py-0"
    >
      <v-icon
        :icon="row.ok ? 'mdi-check-circle' : 'mdi-circle-outline'"
        :color="row.ok ? 'success' : 'grey'"
        size="small"
        class="flex-shrink-0"
      />
      <span :class="row.ok ? 'text-success' : 'text-medium-emphasis'">{{ row.label }}</span>
    </div>
  </div>
</template>

<script>
import { passwordPolicyState } from "@/assets/js/formRules.js";

export default {
  props: {
    password: {
      type: String,
      default: "",
    },
  },
  computed: {
    rows() {
      const st = passwordPolicyState(this.password);
      return [
        { key: "len", ok: st.minLength, label: "Au moins 8 caractères" },
        { key: "up", ok: st.upper, label: "Une lettre majuscule" },
        { key: "lo", ok: st.lower, label: "Une lettre minuscule" },
        { key: "dig", ok: st.digit, label: "Un chiffre" },
        { key: "spec", ok: st.special, label: "Un caractère spécial (!, ?, #, etc.)" },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.password-policy-hints .ga-1 {
  gap: 6px;
}
</style>
